// extracted by css-extract-rspack-plugin
export default {"container":"container-WltuKq","slider":"slider-JDRRRM","tab":"tab-rdLReD","tabActive":"tabActive-dP83BD"};